<script lang="ts">
import { onMount } from "svelte";

    import Button from "../materialize/components/Button.svelte";
    import ModalWindow from "../materialize/components/ModalWindow.svelte";
    import Column from "../materialize/grid/Column.svelte";
    import Row from "../materialize/grid/Row.svelte";
    import { allow_analytics } from "../stores/stores";
    function accept() {
        modal.close();
        $allow_analytics = 1;
    }
    function refuse() {
        modal.close();
        $allow_analytics = -1;
    }

    let modal;
    onMount(()=>{
        modal.open();
    });
</script>

<ModalWindow bind:this={modal} title="Informativa sulla privacy">
    <Row>
        <Column>
            <h5>Cosa e perché?</h5>
            <p>Capire quali pagine di Appröu vengono più visitate e quale dispositivo le persone usino di più per navigare è utile per farci focalizzare nella giusta direzione.</p>
            <p>Desideriamo salvare temporaneamente alcune informazioni di navigazione: indirizzo IP, tipo di dispositivo e browser che usi, data e ora del collegamento.</p>
            <h5>Come li proteggete? Li eliminate?</h5>
            <p>L'indirizzo IP viene pseudoanonimizzato.
                <br>Dopo un mese vengono conservate solo statistiche aggregate e anonime; vengono cancellati sia l'IP, sia quelle relative al tuo dispositivo.
            </p>
            <h5>
                Vendete i miei dati o li cedete ad aziende esterne a scopo pubblicitario?
            </h5>
            <p>
                <strong>No.</strong>
                <br/>
                Al contrario di molti siti di oggi, Appröu <strong>non</strong> vende
                i dati sulla tua navigazione ad altri.
                <br>
                Il server è nel territorio dell'Unione Europea, quindi sottoposto alle rigide normative europee in fatto di privacy.
                <br><br>
                I dati del server Appröu rimangono nel server Appröu.
            </p>
            <h5>Posso usare ugualmente Appröu anche se rifiuto?</h5>
            <p>Certo! <br>
            In quel caso Appröu saprà soltanto che "qualcuno anonimo ha cercato questa parola", ma non da dove o da che dispositivo</p>
            <p>
                Tuttavia, pensiamo che Appröu dimostra di prestare molta attenzione a queste tematiche, motivo per cui molti dei nostri utenti scelgono di accettare.
                <br> Detto ciò, la scelta sta unicamente a te.
            </p>
        </Column>
    </Row>
    <Row>
        <Button size="large" on:click={refuse}>Rifiuta</Button>
        <Button size="large" on:click={accept}>Accetta</Button>
    </Row>
</ModalWindow>
